import React from 'react'
import { Button, Result } from 'antd'
import { withRouter } from 'react-router'
import { reqActivate } from '../../api'

class Activate extends React.Component {
    state = {
        result: <Result status="500" title="500" subTitle="Sorry, something went wrong." />
    }

    onClick = (e) => {
        this.props.history.push('/user/login')
    }

    async componentDidMount() {
        const uidb64 =  this.props.match.params.uidb64
        const token =  this.props.match.params.token
        const activate_result = await reqActivate(uidb64, token)
        
        if (activate_result.code === 0){
            this.setState({
                result: <Result
                    status="success"
                    title={activate_result.message}
                    subTitle="You can log in now."
                    extra={<Button type="primary" onClick={this.onClick}>Log in</Button>}
                />
            })
        } else if (activate_result.code === 400) {
            this.setState({
                result: <Result
                    status="error"
                    title={activate_result.message}
                    subTitle="Please contact Administrator."
                />
            })
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.result}
            </React.Fragment>
        )
    }
}

export default withRouter(Activate)